/**
 * @function increment
 * @param {number} num number to increment
 * @returns {number} incremented number
 */
export const increment = (num: number): number => num + 1;
